"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/components/Instructors.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Card_Instructor_template = require("../../../components/Card-Instructor.marko"),
    Card_Instructor_tag = marko_loadTag(Card_Instructor_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "theme-bg pr-4 py-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("4aa75d"),
    marko_node0 = marko_createElement("br", null, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "4", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  if (Array.isArray(input.list) && input.list.length) {
    out.be("section", marko_attrs0, "0", component);

    out.be("h5", null, "1", component);

    Locale_tag({
        text: "Instructors"
      }, out, __component, "2");

    out.ee();

    out.n(marko_node0, component);

    out.n(marko_node1, component);

    Row_tag({
        renderBody: function(out) {
          marko_forOf(input.list, function(instructor, index) {
            Card_Instructor_tag(instructor, out, __component, index);
          });
        }
      }, out, __component, "5");

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
